// ADDED
import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import SendIcon from '@mui/icons-material/Send';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { LeaveIncentiveBatchStatus } from "../../../../../utils/enums";
import { formatCurrency, formatDateLong } from "../../../../../utils/textUtils";
import { StatusBadge } from "../../../../../common/Badge";

const LeaveIncentiveTable = ({ data, onRelease, onView, loading, currentPage, setCurrentPage }) => {
  const headers = ["Employee Id", "Employee", "Amount", "Status", "Tenure", "DateEmployed", "Actions"];
  const accessors = ["employeeId", "employeeFullName", "amount", "status", "tenure", "dateEmployed", "actions"];

  const actions = [
    {
      name: "Release",
      icon: <SendIcon fontSize="small" />,
      className: "bg-amber-500 hover:bg-amber-600 text-white",
      function: onRelease,
      visible: (item) => item.status === LeaveIncentiveBatchStatus.PENDING,
    },
    {
      name: "View",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 text-white",
      function: (row) => onView(row),
      visible: true,
    },
  ];

  const customRender = (row, accessor) => {
    if (accessor === "amount") return formatCurrency(row[accessor]);
    if (accessor === "dateEmployed") return formatDateLong(row[accessor]);
    if (accessor === "status") return <StatusBadge status={row[accessor]} />;
    return null;
  };

  return (
    <CreateTable
      tableName="Leave Incentive"
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
      customCellRenderer={customRender}
    />
  );
};

export default LeaveIncentiveTable;